import { faExclamationTriangle, faSpinner } from '@fortawesome/free-solid-svg-icons';
import {
    Item,
    LocationDataStore,
    locationSelectors,
    Movement,
    MovementDataStore,
    movementSelectors,
    MovementTypes,
} from '@skinsoft/entity';
import { fetch } from '@skinsoft/network';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import bModal from 'bootstrap-vue/es/components/modal/modal';
import { FORM_ERROR } from 'final-form';
import { Component, Watch } from 'vue-property-decorator';

import { LocationSelector } from '@skinsoft/entity-ui';
import { CloseForm, Values } from './close-form';

@Component({
    components: {
        sCloseForm: CloseForm,
    },
    props: ['committedItems', 'movement'],
    template: require('./close-movement-modal.html'),
})
export class CloseMovementModal extends ReactiveVue {
    public committedItems: Array<Item['id']>;
    public movement: Movement;
    public loadingIcon = faSpinner;
    public warningIcon = faExclamationTriangle;
    public canBeClosed = false;
    public initialValues: Values = {
        location: null as any,
        permanentLocation: false,
    };
    public mounted = false;

    public $locationDataStore: LocationDataStore;
    public $movementDataStore: MovementDataStore;
    public $refs: {
        modal: bModal;
    };
    public movementSelectors = movementSelectors;

    public open() {
        this.$refs.modal.show();
    }

    public onHide() {
        this.canBeClosed = false;
        this.mounted = false;
    }

    public onShow() {
        this.mounted = true;
    }

    public async onSubmit(values) {
        let locationId;

        if (movementSelectors.movementType(this.movement) === MovementTypes.SIMPLE) {
            locationId = values.location.id;
        }

        try {
            await this.$movementDataStore.closeMovement(
                this.movement.id,
                locationId,
                values.permanentLocation,
            );

            (this.$refs.modal as any).hide();
        } catch (error) {
            return {
                [FORM_ERROR]: fetch.isNetworkError(error)
                    ? 'entity.closeMovement.error.network'
                    : 'entity.closeMovement.error.api',
            };
        }
    }

    @Watch('mounted')
    private onMountedChange(value: boolean) {
        this.$emit('mounted', value);
    }
}
